import { useTranslation } from 'react-i18next';
import { LANGUAGE_NAMES, type AdminOverview, type UiLanguage } from '@b4b/shared';

export default function TranslationsTable({ overview }: { overview: AdminOverview }) {
  const { t } = useTranslation();
  const rows = overview.translations.byLang;
  return (
    <section className="rounded-2xl border border-neutral-200 bg-white p-4 dark:border-neutral-800 dark:bg-neutral-900">
      <h2 className="mb-2 font-semibold">{t('admin.translations.title')}</h2>
      {rows.length === 0 ? (
        <p className="text-sm text-neutral-500">{t('admin.translations.empty')}</p>
      ) : (
        <table className="w-full text-sm">
          <thead className="text-left text-xs text-neutral-500">
            <tr><th className="py-1">{t('admin.translations.lang')}</th><th className="py-1 text-right">{t('admin.translations.cards')}</th><th className="py-1 text-right">{t('admin.translations.fullOk')}</th><th className="py-1 text-right">{t('admin.translations.fullFailed')}</th></tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r.lang} className="border-t border-neutral-100 dark:border-neutral-800">
                <td className="py-1">{LANGUAGE_NAMES[r.lang as UiLanguage] ?? r.lang}</td>
                <td className="py-1 text-right tabular-nums">{r.cards}</td>
                <td className="py-1 text-right tabular-nums">{r.fullOk}</td>
                <td className={`py-1 text-right tabular-nums ${r.fullFailed ? 'text-red-600 dark:text-red-400' : ''}`}>{r.fullFailed}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </section>
  );
}
